class FooterNewsletterForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form.footer__newsletter');
    if (!this.form) return;

    this.input = this.form.querySelector('input[type="email"]');
    this.errorEl = this.form.querySelector('.newsletter-form__message--error');
    this.errorTextEl = this.errorEl?.querySelector('.newsletter-form__message-text');
    this.successEl = this.form.querySelector('.newsletter-form__message--success');
    this.button = this.form.querySelector('.newsletter-form__button');

    this.errorDismissTimeout = null;
    this.successDismissTimeout = null;
    this.errorDismissMs = 4000;
    this.successDismissMs = 4000;

    if (this.successEl) {
      this.scheduleSuccessHide();
    }

    if (!this.input || !this.errorEl || !this.errorTextEl) return;

    this.messages = {
      valueMissing: this.dataset.emailRequired || 'Please enter your email address',
      typeMismatch: this.dataset.emailInvalid || 'Please enter a valid email address',
    };

    this.hasServerError = this.errorEl.dataset.serverError === 'true';

    this.form.setAttribute('novalidate', 'novalidate');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onInput = this.onInput.bind(this);

    this.form.addEventListener('submit', this.handleSubmit);

    if (this.button) {
      this.button.setAttribute('type', 'button');
      this.button.addEventListener('click', this.handleSubmit);
    }

    this.input.addEventListener('input', this.onInput);
  }

  disconnectedCallback() {
    this.clearErrorDismissTimeout();
    this.clearSuccessDismissTimeout();
  }

  clearErrorDismissTimeout() {
    if (this.errorDismissTimeout !== null) {
      window.clearTimeout(this.errorDismissTimeout);
      this.errorDismissTimeout = null;
    }
  }

  clearSuccessDismissTimeout() {
    if (this.successDismissTimeout !== null) {
      window.clearTimeout(this.successDismissTimeout);
      this.successDismissTimeout = null;
    }
  }

  scheduleSuccessHide() {
    this.clearSuccessDismissTimeout();
    this.successDismissTimeout = window.setTimeout(() => {
      this.hideSuccess();
    }, this.successDismissMs);
  }

  hideSuccess() {
    this.clearSuccessDismissTimeout();
    if (!this.successEl) return;

    this.successEl.classList.add('hidden');
    this.successEl.hidden = true;
    this.successEl.setAttribute('aria-hidden', 'true');

    if (this.input?.getAttribute('aria-describedby') === this.successEl.id) {
      this.input.removeAttribute('aria-describedby');
    }
  }

  handleSubmit(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const errorMessage = this.getErrorMessage();

    if (errorMessage) {
      this.showError(errorMessage);
      this.input.focus();
      return;
    }

    this.hideError();
    this.form.removeEventListener('submit', this.handleSubmit);
    this.form.submit();
  }

  onInput() {
    if (this.hasServerError) return;

    if (!this.getErrorMessage()) {
      this.hideError();
    }
  }

  getErrorMessage() {
    const value = this.input.value.trim();

    if (!value) {
      return this.messages.valueMissing;
    }

    if (!value.includes('@') || !value.includes('.')) {
      return this.messages.typeMismatch;
    }

    return null;
  }

  showError(message) {
    this.clearErrorDismissTimeout();
    this.errorTextEl.textContent = message;
    this.errorEl.classList.remove('hidden');
    this.errorEl.hidden = false;
    this.input.setAttribute('aria-invalid', 'true');
    this.input.setAttribute('aria-describedby', this.errorEl.id);

    if (!this.hasServerError) {
      this.errorDismissTimeout = window.setTimeout(() => {
        this.hideError();
      }, this.errorDismissMs);
    }
  }

  hideError() {
    this.clearErrorDismissTimeout();
    if (this.hasServerError) return;

    this.errorEl.classList.add('hidden');
    this.errorEl.hidden = true;
    this.errorTextEl.textContent = '';
    this.input.removeAttribute('aria-invalid');
    this.input.removeAttribute('aria-describedby');
  }
}

if (!customElements.get('footer-newsletter-form')) {
  customElements.define('footer-newsletter-form', FooterNewsletterForm);
}
